import { getPermissions } from "@/apis/getPermisions";
// import * as localforage from "localforage";

// export const checkHasPermission = async (permission) => {
//     const userPermissions = await localforage.getItem("userPermissions");
//     if (userPermissions) {
//         const isPermission = userPermissions.includes(permission);
//         return !!isPermission;
//     }
// };

export const checkHasPermission = permission => {
  // if (process.env.NODE_ENV === "development") {
  //   return true;
  // }
  const userPermissions = getPermissions();
  if (userPermissions) {
    const isPermission =
      !permission ||
      permission === "No Permission" ||
      (Array.isArray(permission)
        ? permission.every(p => userPermissions.includes(p))
        : userPermissions.includes(permission));
    return isPermission;
  }
  return false;
};
